export default [
  {
    path: '/match-video',
    name: 'list-match-video',
    component: () => import('@/views/matchVideo/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.matchVideo',
      resource: 'video-live-upload',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listMatchVideo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/match-video/create',
    name: 'create-match-video',
    component: () => import('@/views/matchVideo/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.matchVideo',
      navActiveLink: 'list-match-video',
      resource: 'video-live-upload',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listMatchVideo',
          to: { name: 'list-match-video' },
        },
        {
          text: 'breadcrumb.createMatchVideo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/match-video/:id/update',
    name: 'update-match-video',
    component: () => import('@/views/matchVideo/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.matchVideo',
      navActiveLink: 'list-match-video',
      resource: 'video-live-upload',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listMatchVideo',
          to: { name: 'list-match-video' },
        },
        {
          text: 'breadcrumb.updateMatchVideo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/match-video/:id',
    name: 'view-match-video',
    component: () => import('@/views/matchVideo/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.matchVideo',
      navActiveLink: 'list-match-video',
      resource: 'video-live-upload',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listMatchVideo',
          to: { name: 'list-match-video' },
        },
        {
          text: 'breadcrumb.viewMatchVideo',
          active: true,
        },
      ],
    },
  },
]
